<template>
  <!--
    Example Data
{ name: 'between', input_type: 'range', range_type: 'number',
  range_keys: ['min', 'max'], unit_of_measure: 'sales', label: 'Foo'}
  -->
  <v-row>
    <v-col md="3">
      <div class="mr-5 mt-6">
        <div class="text-right subtitle font-weight-bold">{{ fieldLabel | capitalize }}</div>
      </div>
    </v-col>
    <v-col class="d-flex d-inline" md="9" >
      <template v-for="range_key in value.range_keys">
        <v-text-field
            :key="range_key"
            :label="range_key | capitalize"
            :suffix="value.unit_of_measure"
            :type="value.range_type"
            :value="modelValue[rangeKeyFullName(range_key)]"
            :min="value.range_opts.min"
            :max="value.range_opts.max"
            v-on:change="$emit('update-query-param-value', {name: paramName, key: rangeKeyFullName(range_key), value: $event})"
            class="mr-6"
            :rules="vruleFieldRequired"
            required
          ></v-text-field>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import validationMixin from '@/validators/validations_mixin'
import { isNil } from 'ramda'

export default {
  name: 'range-input-field',
  inputType: 'range',
  mixins: [validationMixin],
  props: {
    value: {
      type: Object,
      require: true
    },
    paramName: {
      type: String,
      require: true
    },
    modelValue: {
      type: Object,
      require: true
    },
    errorMessages: {
      type: Array
    }
  },
  data: function () {
    return {}
  },
  computed: {
    fieldLabel () {
      if (this.value) {
        // explicict check for nil - we *do* want to allow '' as a label
        if (isNil(this.value.label)) {
          return this.value.name
        } else {
          return this.value.label
        }
      } else {
        return ''
      }
    }
  },
  methods: {
    rangeKeyFullName (keyName) {
      return `${this.value.name}_${keyName}`
    }
  }
}
</script>
